<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <el-button type='primary' icon='sys sys-check' class='navbarbtn' v-if='showCheckDocumentPower'
        @click='checkPPO'>
        审 核
      </el-button>

      <el-button type='danger' icon='sys sys-cancelcheck' class='navbarbtn' v-if='showCancelCheckDocumentPower'
        @click='cancelCheckPPO'>
        撤销审核
      </el-button>

      <el-button type='primary' icon='sys sys-reject' class='navbarbtn' v-if='showRejectDocumentPower'
        @click='showRejectPPODialogMD'>
        驳 回
      </el-button>

      <el-button type='danger' icon='sys sys-cancel' class='navbarbtn' v-if='showCancelRejectDocumentPower'
        @click='cancelRejectPPO'>
        撤销驳回
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='90px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      :expandRowKeys='mainTable.expandRowKeys'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='操作日志' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showPOOrderLogDialogMD(scope)'><i class='sys sys-log'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='材料明细' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='POOrderDocument = scope.data.row.detailDt2; showPOOrderDocumentDialog = true'><i class='sys sys-file'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>含税单价</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>价税合计</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>税率</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 90px; text-align: left;'><span style='color: #42426F;'>交期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 90px; text-align: left;'><span style='color: #42426F;'>回复交期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>生成标签</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>到货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>入库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>退货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='ppoe in scope.data.row.detailDt1' :style='mainTableDetail1RowStyle(scope.data.row, ppoe)'
            :key='ppoe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppoe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.Qty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.AuxTaxPrice}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{typeof (ppoe.AllAmount) === 'number' ? ppoe.AllAmount.toFixed(2) : ''}} </span></div>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppoe.Cess}}% </span></div>
            <div class='expand-row' style='min-width: 90px; text-align: left;'><span style='color: blue;'>{{ppoe.DevDate.substring(0, 10)}} </span></div>
            <div class='expand-row' style='min-width: 90px; text-align: left;'><span style='color: blue;'>{{ppoe.NewDevDate ? ppoe.NewDevDate.substring(0, 10) : ''}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppoe.CreateQRCodeQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.CommitQty + ppoe.ReturnQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.StockQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.ReturnQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemModel}} </span></div>
          </div>
        </div>
      </template>
      <template #slot-DocumentRejectReason='scope'>
        <input v-model='scope.data.row.DocumentRejectReason' style='width: 230px;' class='tableInput'/>
      </template>
    </Table>

    <el-dialog v-dialogDrag title='操作日志' :visible.sync='showPOOrderLogDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='POOrderLog' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='LogNo' label='记录号' width='160'>
        </el-table-column>
        <el-table-column prop='Content' label='操作内容' width='500'>
        </el-table-column>
        <el-table-column prop='CreateTime' label='操作时间' width='160'>
          <template #default='scope'>
            {{dateTimeUtil.formartDateTime(new Date(scope.row.CreateTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop='CreateUserName' label='操作人' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog v-dialogDrag title='材料明细' :visible.sync='showPOOrderDocumentDialog' width='670px'
      top='10px' lock-scroll>
      <el-table :data='POOrderDocument' border height='250px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='DocumentName' label='材料名称' width='400'>
          <template #default='scope'>
            <a target='_blank' :href='scope.row.FilePath'>{{scope.row.DocumentName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop='CreateTime' label='操作时间' width='160'>
          <template #default='scope'>
            {{dateTimeUtil.formartDateTime(new Date(scope.row.CreateTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog v-dialogDrag title='驳回原因' :visible.sync='showRejectPPODialog' width='300px'
      top='20vh' lock-scroll>
      <div style='margin-top: -30px;'>
        <el-input v-model='rejectReason' size='mini'></el-input>
      </div>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='rejectPPO()' size='mini'>确定</el-button>
        <el-button @click='showRejectPPODialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import code from '@/components/sys/Code'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'POrderCheckDocument',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PO_POOrder_3',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        customFilterStr: ' AND 1=0 ',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: [],

        tranTypes: [],
        poStyles: [],
        poModes: [],
        areaPSs: [],
        statuss: [],
        cancellations: [],
        closeds: [],
        uploadDocumentStatuss: [],
        documentCommitStatuss: [],
        documentCheckStatuss: [],
        haveDevDateChangeFlags: [],
        createDeliveryStatuess: [],
        headSelfP0239s: [],
        headSelfP0242s: []
      },

      dateTimeUtil: dateTimeUtil,

      showPOOrderLogDialog: false,
      POOrderLog: [],

      showPOOrderDocumentDialog: false,
      POOrderDocument: [],

      showRejectPPODialog: false,
      rejectReason: '',

      showCheckDocumentPower: false,
      showCancelCheckDocumentPower: false,
      showRejectDocumentPower: false,
      showCancelRejectDocumentPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.mainTable.tranTypes = code.getCode(codes, 'TM_TranType')
    that.mainTable.poStyles = code.getCode(codes, 'PO_POOrder_POStyle')
    that.mainTable.poModes = code.getCode(codes, 'PO_POOrder_POMode')
    that.mainTable.areaPSs = code.getCode(codes, 'PO_POOrder_AreaPS')
    that.mainTable.statuss = code.getCode(codes, 'PO_POOrder_Status')
    that.mainTable.cancellations = code.getCode(codes, 'TM_Cancellation')
    that.mainTable.closeds = code.getCode(codes, 'TM_Closed')
    that.mainTable.uploadDocumentStatuss = code.getCode(codes, 'PO_POOrder_UploadDocumentStatus')
    that.mainTable.documentCommitStatuss = code.getCode(codes, 'PO_POOrder_DocumentCommitStatus')
    that.mainTable.documentCheckStatuss = code.getCode(codes, 'PO_POOrder_DocumentCheckStatus')
    that.mainTable.createDeliveryStatuess = code.getCode(codes, 'PO_POOrder_CreateDeliveryStatues')
    that.mainTable.haveDevDateChangeFlags = code.getCode(codes, 'PO_POOrder_HaveDevDateChangeFlag')
    that.mainTable.headSelfP0239s = code.getCode(codes, 'PO_POOrder_HeadSelfP0239')
    that.mainTable.headSelfP0242s = code.getCode(codes, 'PO_POOrder_HeadSelfP0242')

    const rtnObjPromise = axiosHelper.handle('/WebAction/BaseData.User.GetUserSupply', {
    })
    const rtnObj = await rtnObjPromise
    if (rtnObj && rtnObj.error === '000000') {
      if (rtnObj.supplyRoleFlag === '0' && rtnObj.purchaseManagerRoleFlag === '0') {
        that.mainTable.customFilterStr = ''
      } else {
        let customFilterStr = " AND SupplyID IN (''"
        for (let i = 0; i < rtnObj.supplys.length; i++) {
          customFilterStr += ",'" + rtnObj.supplys[i].SupplyID + "'"
        }
        customFilterStr += ')'
        that.mainTable.customFilterStr = customFilterStr
      }
    }
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.mainTable.detail1FilterStr = ''
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      const that = this
      if (columnCode === 'TranType') {
        return that.mainTable.tranTypes
      } else if (columnCode === 'POStyle') {
        return that.mainTable.poStyles
      } else if (columnCode === 'POMode') {
        return that.mainTable.poModes
      } else if (columnCode === 'AreaPS') {
        return that.mainTable.areaPSs
      } else if (columnCode === 'Status') {
        return that.mainTable.statuss
      } else if (columnCode === 'Cancellation') {
        return that.mainTable.cancellations
      } else if (columnCode === 'Closed') {
        return that.mainTable.closeds
      } else if (columnCode === 'UploadDocumentStatus') {
        return that.mainTable.uploadDocumentStatuss
      } else if (columnCode === 'DocumentCommitStatus') {
        return that.mainTable.documentCommitStatuss
      } else if (columnCode === 'DocumentCheckStatus') {
        return that.mainTable.documentCheckStatuss
      } else if (columnCode === 'CreateDeliveryStatues') {
        return that.mainTable.createDeliveryStatuess
      } else if (columnCode === 'HaveDevDateChangeFlag') {
        return that.mainTable.haveDevDateChangeFlags
      } else if (columnCode === 'HeadSelfP0239') {
        return that.mainTable.headSelfP0239s
      } else if (columnCode === 'HeadSelfP0242') {
        return that.mainTable.headSelfP0242s
      }
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Closed === '1' || data.row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '3') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '2' || data.row.Status === '1') {
        if (data.row.DocumentCheckStatus === '1') {
          return { 'background-color': '#00FF7F' }
        } if (data.row.DocumentCommitStatus === '2') {
          return { 'background-color': '#FF4500' }
        } else if (data.row.DocumentCommitStatus === '1') {
          return { 'background-color': '#99ffff' }
        } else if (data.row.UploadDocumentStatus === '1') {
          return { 'background-color': 'orange' }
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 展开行行样式设定方法
    mainTableDetail1RowStyle: function (row, ppoe) {
      if (row.Closed === '1' || row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (row.Status === '3' || ppoe.ErpClosed === '1') {
        return { 'background-color': '#cccccc' }
      }
    },

    // 显示采购相关日志
    showPOOrderLogDialogMD: async function (scope) {
      const that = this
      that.POOrderLog = scope.data.row.detailDt3
      that.showPOOrderLogDialog = true
    },

    // 材料审核
    checkPPO: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      let haveDevDateChangeCount = 0
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].HaveDevDateChangeFlag === '1') {
          haveDevDateChangeCount++
        }
      }
      if (haveDevDateChangeCount <= 0) {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CheckPOOrder', {
          ppos: that.mainTable.selections
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('审核成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      } else {
        that.$confirm('您选择的订单中有' + haveDevDateChangeCount + '笔订单存在交期变更，是否已经确认无误?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const loadingInstance = Loading.service({ fullscreen: true })
          const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CheckPOOrder', {
            ppos: that.mainTable.selections
          })
          if (rtnObj.error === '000000') {
            that.refreshMainTableContent()
            that.$message.success('审核成功！')
          } else {
            that.$message.error(rtnObj.msg)
          }
          loadingInstance.close()
        }).catch(() => {
        })
      }
    },

    // 撤销材料审核
    cancelCheckPPO: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CancelCheckPOOrder', {
        ppos: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('撤销审核成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 显示驳回原因输入框
    showRejectPPODialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      if (that.mainTable.selections.length > 1) {
        that.$message.error('请选择单条数据！')
        return
      }
      that.showRejectPPODialog = true
      that.rejectReason = ''
    },

    // 材料驳回
    rejectPPO: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      if (that.mainTable.selections.length > 1) {
        that.$message.error('请选择单条数据！')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        // if (!that.mainTable.selections[i].DocumentRejectReason) {
        //   that.$message.error('请输入采购订单【' + that.mainTable.selections[i].BillNo + '】的驳回原因！')
        //   return
        // }
        that.mainTable.selections[i].DocumentRejectReason = that.rejectReason
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.RejectPOOrder', {
        ppos: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('驳回成功！')
        that.showRejectPPODialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 撤销材料驳回
    cancelRejectPPO: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.CancelRejectPOOrder', {
        ppos: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('撤销驳回成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 20px;
  line-height: 20px;
  border: 0;
  background-color: transparent;
  padding: 0;
}
</style>
